module.exports = __webpack_public_path__ + "static/dynamic-pricing-iso.79f53dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-works/dynamic-pricing-iso.png
// module id = 504
// module chunks = 35783957827783